var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#5244D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83125 15.4125C5.19637 15.4125 2.25 12.4661 2.25 8.83125C2.25 5.19637 5.19637 2.25 8.83125 2.25C12.4661 2.25 15.4125 5.19637 15.4125 8.83125C15.4125 12.4661 12.4661 15.4125 8.83125 15.4125ZM10.4569 11.0813L8.83125 8.83125L7.20563 11.0813L5.88375 8.83125L7.3575 6.31125H10.305L11.7788 8.83125L10.4569 11.0813ZM10.9406 5.23125H6.72187L4.61812 8.83125L6.7275 12.4313H10.9406L13.0444 8.83125L10.9406 5.23125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbx);
export default __webpack_public_path__ + "static/media/tbx.04a8a244ae68bbd139e85294d83ad06d.svg";
export { ForwardRef as ReactComponent };